import * as React from 'react';

import { ListView } from '@longline/aqua-ui/controls/ListView/ListView';
import { SecondaryButton } from '@longline/aqua-ui/controls/SecondaryButton';
import { SVG } from '@longline/aqua-ui/svg';
import { Key } from '@longline/aqua-ui/controls/Key';
import { Message } from '@longline/aqua-ui/containers/Message';

import { useGlobalState } from '../../contexts/state/GlobalStateContext';
import { useConfirm } from '../../contexts/confirm/ConfirmContext';
import { AreaSimpleInfoBox } from '../../infoboxes/AreaSimpleInfoBox';
import { IArea } from '../../types/IArea';
import { Guide } from '../../ui/Guide';
import { Pane } from '../../ui/Pane';

const AreaPane = () => {
  const confirm = useConfirm();
  const globalState = useGlobalState();

  const handleDeleteAll = () => {
    globalState.clearAreas();
  }

  const handleAdd = () => {
    globalState.setSelectedArea(null);
    globalState.clearStructureSelection();
    globalState.setMode('area-builder');
  }  

  return (
    <>
      
      <Pane.Heading>
        <Pane.Title>Simulation areas</Pane.Title>
      </Pane.Heading>
      <Pane.Subheader expandable action={<SecondaryButton title="Add area" positive icon={SVG.Icons.Plus} onClick={handleAdd}/>}>
        Add area
      </Pane.Subheader>
      
      <ListView 
        dark 
        data={globalState.areas} 
        active={globalState.selectedArea}
        onClick={(rect) => globalState.setSelectedArea(rect)} 
        shadow
        aux={<AreaSimpleInfoBox/>}
        total
        singular="area"
        plural="areas"
        noData={<Message margin>There are no simulation areas yet.</Message>}
        rowHeight={56}
      >
        <ListView.Column active width={3} name="Name">{(item: IArea) => item.name}</ListView.Column>
      </ListView>

      {globalState.areas.length > 0 &&
        <Pane.Fab negative title="Delete all areas" icon={SVG.Icons.Delete} onClick={() => confirm.start(handleDeleteAll, "Delete all areas", "Are you sure you wish to delete all simulation areas?")}/>}

      {globalState.selectedArea == null && globalState.selectedStructures.length === 0 &&
        <Pane.Guide>
          <Guide x={0} y={0} title="Simulation areas">
            Click <Key value="+"/> to create a new simulation area.
          </Guide>
        </Pane.Guide>}
    </>
  )
}

export { AreaPane }
